import { useCallback } from 'react';

export default function useCreateQueryString(searchParams) {
  return useCallback(
    (...entries) => {
      const params = new URLSearchParams(searchParams.toString());

      for (const [name, value] of entries) {
        params.set(name, value);
      }

      return params.toString();
    },
    [searchParams]
  );
}
